<template>
    <ProductLabel
        v-if="product.shop_availability && product.is_special"
        text="SALE"
        :absolute="absolute"
        :extra-class="extraClass"
    />
    <ProductQuantityPricesPopover
        v-else-if="product.shop_availability && product.quantity_prices.length > 1 && !isCorporate"
        :absolute="absolute"
        :product="product"
    >
        <ProductLabel
            text="TIER PRICING"
            :absolute="absolute"
            :extra-class="extraClass"
        />
    </ProductQuantityPricesPopover>
    <ProductLabel
        v-else-if="!product.shop_availability"
        text="SOLD OUT"
        :absolute="absolute"
        :extra-class="extraClass"
    />
    <ProductLabel
        v-else-if="product.exclusive"
        text="EXCLUSIVE"
        :absolute="absolute"
        :extra-class="extraClass"
    />
    <ProductLabel
        v-else-if="product.pre_sale"
        text="PRESALE"
        :absolute="absolute"
        :extra-class="extraClass"
    />
    <ProductQuantityPricesPopover
        v-else-if="showTierPricing && product.quantity_prices.length > 0 && isCorporate"
        :absolute="absolute"
        :product="product"
    >
        <ProductLabel
            text="TIER PRICING"
            :absolute="absolute"
            :extra-class="extraClass"
        />
    </ProductQuantityPricesPopover>
<!--    <ProductLabel-->
<!--        v-else-if="product.available_for_storage_stock_id"-->
<!--        text="STORAGE"-->
<!--        :absolute="absolute"-->
<!--    />-->
</template>

<script setup>
const ProductLabel = defineAsyncComponent(() => import("~/components/Product/ProductLabel.vue"));
const ProductQuantityPricesPopover = defineAsyncComponent(() => import("~/components/Product/ProductQuantityPricesPopover.vue"));

const props = defineProps({
    product: Object,
    absolute: Boolean,
    showTierPricing: Boolean,
    extraClass: String
});

const userStore = useUserStore();

const isCorporate = userStore.user?.is_corporate;
</script>
